import {
  PhaseStructureTypeEnum,
  RegionAuditInterface,
} from '@vatos-pas/common';
import {
  auditColumnsToCsvColumns,
  CHANGED_BY_CSV_COLUMN,
  CostStructureHistoryRow,
  CsvColumn,
  TIMESTAMP_CSV_COLUMN,
  WithDecimalCells,
} from 'utils/costStructureHistoryCsv';
import {
  getCostColumnsForWorkflow,
  RegionAuditCostField,
  REGION_AUDIT_ALLOW_PAYOUT_EDITING_COLUMN,
  REGION_AUDIT_SPECIAL_JOBS_COLUMN,
} from './auditColumns';

type RegionAuditDecimalField = RegionAuditCostField | 'specialJobsPercentage';

export type RegionAuditCsvRow = WithDecimalCells<
  Pick<
    RegionAuditInterface,
    RegionAuditDecimalField | 'allowPayoutAmountEditing'
  >,
  RegionAuditDecimalField
> &
  CostStructureHistoryRow;

/**
 * Same order and labels as the on-screen table; Production Pricing and
 * Override are Subdivision-only, so they are absent here.
 */
export const getRegionAuditCsvColumns = (
  phaseStructureType: PhaseStructureTypeEnum,
): CsvColumn<RegionAuditCsvRow>[] => [
  CHANGED_BY_CSV_COLUMN,
  TIMESTAMP_CSV_COLUMN,
  ...auditColumnsToCsvColumns<RegionAuditCsvRow>([
    ...getCostColumnsForWorkflow(phaseStructureType),
    REGION_AUDIT_SPECIAL_JOBS_COLUMN,
    REGION_AUDIT_ALLOW_PAYOUT_EDITING_COLUMN,
  ]),
];
